function PageWrapper({ children }) {
    return (
      <div className="background">
        <div className="pageWrapper">{children}</div>
      </div>
    );
  }
  
  export default PageWrapper;
  